import { useTranslations } from 'next-intl';
import Info from 'assets/icons/info.svg';
import styles from './rights-restricted-message.module.scss';
import { type CSSProperties } from 'react';

const RightsRestrictedMessage = ({
	backgroundColor = 'var(--color-grey-050)',
	color = 'var(--color-grey-900)',
}: IProps) => {
	const t = useTranslations();
	return (
		<figcaption
			data-testid="rights-restricted-message"
			className={styles.message}
			style={
				{
					'--background-color': backgroundColor,
					'--color': color,
				} as CSSProperties
			}
		>
			<Info className={styles.icon} /> {t('rightsRestricted')}
		</figcaption>
	);
};

interface IProps {
	backgroundColor?: string;
	color?: string;
}

export default RightsRestrictedMessage;
